import React from "react";
import {CircularProgress, useTheme} from "@mui/material";

interface EnhancedCircularLoaderProps {
    styles?: React.CSSProperties;
    [key: string]: any;
}

export default function EnhancedCircularLoader(props: EnhancedCircularLoaderProps) {
    const theme = useTheme();
    return (
        <div style={{
            display: "flex",
            height: "100%",
            width: "100%",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <CircularProgress
                style={{color: theme.palette.tertiary.main, width: "80px", height: "80px", ...props.styles}}/>
        </div>
    );
}
